module.exports = __webpack_public_path__ + "img/image14-1.dcbd061a.png";